import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { SupportGrantsPage } from './SupportGrantsPage';

/** Screens of this feature (A3). */
export const routes: FeatureRoute[] = [
  {
    path: 'support',
    element: (
      <RequireCapability anyOf={['tenants.view']} what="support access">
        <SupportGrantsPage />
      </RequireCapability>
    ),
  },
];
